// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill';
import Vue from 'vue'
import store from './store'
import Element from 'element-ui'
import echarts from 'echarts'
import "./icons/iconfont.css"
import './styles/element-variables.scss'
import './permission'

import * as userContext from '@/utils/userContext'
import * as uiHelper from '@/utils/uiHelper'

import * as domainApi from '@/api/domainApi'
import * as userContextApi from '@/api/userContextApi'
import * as organizationApi from '@/api/organizationApi'
import * as userApi from '@/api/userApi'
import * as roleApi from '@/api/roleApi'
import * as projectApi from '@/api/projectApi'
import * as taskApi from '@/api/taskApi'
import * as dateTimeHelperApi from '@/api/dateTimeHelperApi'
import * as weeklyReportApi from '@/api/weeklyReportApi'
import * as dictionaryApi from '@/api/dictionaryApi'
import * as fileApi from '@/api/fileApi'
import * as reportApi from '@/api/reportApi'

import App from './App'
import router from './router'
Vue.config.productionTip = false

Vue.use(Element)
Vue.prototype.$echarts = echarts

Vue.prototype.$userContext = userContext
Vue.prototype.$uiHelper = uiHelper

Vue.prototype.$domainApi = domainApi
Vue.prototype.$userContextApi = userContextApi
Vue.prototype.$organizationApi = organizationApi
Vue.prototype.$userApi = userApi
Vue.prototype.$roleApi = roleApi
Vue.prototype.$projectApi = projectApi
Vue.prototype.$taskApi = taskApi
Vue.prototype.$dateTimeHelperApi = dateTimeHelperApi
Vue.prototype.$weeklyReportApi = weeklyReportApi
Vue.prototype.$dictionaryApi = dictionaryApi
Vue.prototype.$fileApi = fileApi
Vue.prototype.$reportApi = reportApi

Vue.filter('hoursToDays', function (value) {
  if (!value) 
    return "0.0";

  return (value / window.Glob.WorkingHours).toFixed(1);
})

// getCommonListSettings()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js